/*
  Yulan v3p - filtres d'une collection sans rechargement de page.
  - Pastilles « Série » : plusieurs séries à la fois (OU logique). Chaque série sélectionnée est
    rendue par Shopify via sa route de tag native (/collections/x/[type+]serie-y?section_id=…) et les
    grilles sont fusionnées côté client (une seule requête par série, en parallèle, sans doublon).
  - Pastilles « Type de produit » : un seul type, appliqué de la même façon (fetch + remplacement).
  - Aucune sélection : la grille d'origine (pagination comprise) est rechargée par fetch.
  - L'état est mémorisé dans l'URL (?yv3s=serie-a,serie-b&yv3t=type-x) pour le partage et le retour
    arrière ; les liens des pastilles restent valides sans JavaScript (amélioration progressive).
  Markup : snippets/yulan-v3-type-chips.liquid (data-yv3-filters, data-yv3-chip-type / data-yv3-chip-serie)
  et sections/main-collection-product-grid.liquid (#ProductGridContainer, data-id = section id).
*/
(function () {
  'use strict';
  var root = document.querySelector('[data-yv3-filters]');
  var container = document.getElementById('ProductGridContainer');
  var grid = container && container.querySelector('#product-grid');
  if (!root || !container || !grid || !window.fetch) return;

  var sectionId = grid.getAttribute('data-id');
  var baseUrl = root.getAttribute('data-yv3-base');
  var state = { type: root.getAttribute('data-yv3-type') || '', series: [] };
  var initialSeries = root.getAttribute('data-yv3-serie');
  if (initialSeries) state.series.push(initialSeries);
  var seq = 0;

  function chips(kind) { return Array.prototype.slice.call(root.querySelectorAll('[data-yv3-chip-' + kind + ']')); }

  function readUrlState() {
    var p = new URLSearchParams(location.search);
    if (p.has('yv3s') || p.has('yv3t')) {
      state.series = (p.get('yv3s') || '').split(',').filter(Boolean);
      state.type = p.get('yv3t') || state.type;
      return true;
    }
    return false;
  }

  function keepParams() {
    // conserve le tri et les filtres Shopify (disponibilité, prix) déjà présents dans l'adresse
    var p = new URLSearchParams(location.search);
    p.delete('yv3s'); p.delete('yv3t'); p.delete('page'); p.delete('section_id');
    return p;
  }

  function tagUrl(serie) {
    var tags = [];
    if (state.type) tags.push(state.type);
    if (serie) tags.push(serie);
    var url = baseUrl + (tags.length ? '/' + tags.join('+') : '');
    var p = keepParams();
    p.set('section_id', sectionId);
    return url + '?' + p.toString();
  }

  function writeUrl() {
    var p = keepParams();
    if (state.series.length) p.set('yv3s', state.series.join(','));
    if (state.type) p.set('yv3t', state.type);
    var qs = p.toString();
    history.replaceState(null, '', baseUrl + (qs ? '?' + qs : ''));
  }

  function setLoading(on) {
    var col = container.querySelector('.collection');
    if (col) col.classList.toggle('loading', on);
    root.classList.toggle('is-loading', on);
  }

  function paint() {
    chips('serie').forEach(function (c) {
      var on = state.series.indexOf(c.getAttribute('data-yv3-chip-serie')) >= 0;
      c.classList.toggle('is-active', on);
      // v3s : aria-pressed est interdit sur un lien (erreur Lighthouse) → aria-current
      if (on) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
    });
    var allSeries = root.querySelector('[data-yv3-chip-serie-all]');
    if (allSeries) {
      allSeries.classList.toggle('is-active', state.series.length === 0);
      if (state.series.length === 0) allSeries.setAttribute('aria-current', 'page'); else allSeries.removeAttribute('aria-current');
    }
    chips('type').forEach(function (c) {
      var on = c.getAttribute('data-yv3-chip-type') === state.type;
      c.classList.toggle('is-active', on);
      // v3s : aria-pressed est interdit sur un lien (erreur Lighthouse) → aria-current
      if (on) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
    });
    var allTypes = root.querySelector('[data-yv3-chip-type-all]');
    if (allTypes) {
      allTypes.classList.toggle('is-active', !state.type);
      if (!state.type) allTypes.setAttribute('aria-current', 'page'); else allTypes.removeAttribute('aria-current');
    }
  }

  function productKey(li) {
    var a = li.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href').split('?')[0] : li.innerHTML.length + ':' + li.textContent.trim().slice(0, 40);
  }

  function fetchDoc(url) {
    return fetch(url, { headers: { Accept: 'text/html' } }).then(function (r) { return r.text(); }).then(function (t) {
      return new DOMParser().parseFromString(t, 'text/html');
    });
  }

  function updateCount(n) {
    var ids = ['ProductCount', 'ProductCountDesktop'];
    ids.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.textContent = n + ' produit' + (n > 1 ? 's' : '');
    });
  }

  function render() {
    var my = ++seq;
    setLoading(true);
    var urls = state.series.length ? state.series.map(tagUrl) : [tagUrl('')];
    Promise.all(urls.map(fetchDoc)).then(function (docs) {
      if (my !== seq) return; // une sélection plus récente a pris le relais
      var fresh = docs[0].getElementById('ProductGridContainer');
      if (!fresh) throw new Error('grille absente');
      if (docs.length > 1) {
        var seen = {}, items = [];
        docs.forEach(function (d) {
          var g = d.querySelector('#product-grid');
          if (!g) return;
          Array.prototype.forEach.call(g.children, function (li) {
            var k = productKey(li);
            if (seen[k]) return;
            seen[k] = true;
            items.push(li);
          });
        });
        var target = fresh.querySelector('#product-grid');
        if (target) {
          while (target.firstChild) target.removeChild(target.firstChild);
          items.forEach(function (li, i) { li.style.setProperty('--animation-order', i + 1); target.appendChild(li); });
          var pag = fresh.querySelector('.pagination-wrapper');
          if (pag) pag.parentNode.removeChild(pag); // plusieurs séries fusionnées : pas de pagination unique possible
          var empty = fresh.querySelector('.collection--empty');
          if (!items.length && !empty) target.parentNode.innerHTML = '<div class="title-wrapper center"><h2 class="title title--primary">Aucun produit pour cette sélection.</h2></div>';
        }
        updateCount(items.length);
      } else {
        var c = docs[0].getElementById('ProductCountDesktop') || docs[0].getElementById('ProductCount');
        var m = c && c.textContent.match(/\d+/);
        if (m) updateCount(parseInt(m[0], 10));
      }
      // v3r (2026-10-01) : notre propre remplacement de la grille ne doit PAS être vu par l'observateur plus bas.
      // Avant, un simple drapeau (byUs) l'encadrait, mais un MutationObserver est notifié après coup (microtâche),
      // quand le drapeau est déjà retombé : chaque rendu en relançait un autre toutes les ~80 ms (écran qui
      // clignote, page inutilisable, y compris au rechargement avec ?yv3s=). disconnect() vide aussi les
      // notifications en attente ; on se réabonne juste après.
      if (gridObserver) gridObserver.disconnect();
      container.innerHTML = fresh.innerHTML;
      watchGrid();
      grid = container.querySelector('#product-grid') || grid;
      if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(container);
      document.dispatchEvent(new CustomEvent('yv3:grid-updated'));
    }).catch(function () {
      // en cas d'échec, on laisse le lien natif faire son travail
      location.href = state.series.length === 1 ? tagUrl(state.series[0]).split('?')[0] + location.search : baseUrl;
    }).then(function () { if (my === seq) setLoading(false); });
  }

  root.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-yv3-chip-serie],[data-yv3-chip-type],[data-yv3-chip-serie-all],[data-yv3-chip-type-all]');
    if (!chip || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    if (chip.hasAttribute('data-yv3-chip-serie')) {
      var s = chip.getAttribute('data-yv3-chip-serie');
      var i = state.series.indexOf(s);
      if (i >= 0) state.series.splice(i, 1); else state.series.push(s);
    } else if (chip.hasAttribute('data-yv3-chip-serie-all')) {
      state.series = [];
    } else if (chip.hasAttribute('data-yv3-chip-type')) {
      var t = chip.getAttribute('data-yv3-chip-type');
      state.type = state.type === t ? '' : t;
    } else {
      state.type = '';
    }
    paint();
    writeUrl();
    render();
  });

  window.addEventListener('popstate', function () { if (readUrlState()) { paint(); render(); } });

  // les filtres Shopify (tri, disponibilité, prix — assets/facets.js) remplacent la grille par leur propre
  // requête, sans connaître la sélection de séries : on la réapplique par-dessus quand elle est active
  var gridObserver = window.MutationObserver ? new MutationObserver(function () {
    if (!(state.series.length || state.type)) return;
    clearTimeout(render._t);
    render._t = setTimeout(function () { writeUrl(); render(); }, 80);
  }) : null;
  function watchGrid() { if (gridObserver) gridObserver.observe(container, { childList: true }); }
  watchGrid();

  // premier chargement : une adresse partagée avec ?yv3s=… est rejouée
  if (readUrlState()) { paint(); render(); } else { paint(); }
})();
